import { pathOr } from 'ramda';

export default pathOr;
